export default __webpack_public_path__ + "static/media/discoverOptimalPointPOS.fb076d6a.jpg";